module.exports = __webpack_public_path__ + "static/cosycolour3-9b1759b6209680c01556fa7d17352034.png";